module.exports = __webpack_public_path__ + "img/china.3ff9369.webp";